import { createContext, useState } from "react";

export const ThemeContext = createContext();

export const ThemeContextProvider = ({children})=>{
    const [mode, setMode] = useState(JSON.parse(localStorage.getItem("mode")) || false);
    const toggleThemeMode = ()=>{
        setMode((prevMode) => !prevMode);
        localStorage.setItem("mode", !mode);
    }
    return (
        <ThemeContext.Provider value={{mode, toggleThemeMode}}>
            {children}
        </ThemeContext.Provider>
    )
}